import { jsx } from "react/jsx-runtime";
import React from "react";
import Button from "../Button";
import { useColorScheme } from "../ThemeProvider";
import { MoonIcon, SunIcon } from "@dion-web/ui-icons";
const ThemeSwitcher = (props) => {
  const {
    defaultMode,
    size = "xs",
    ...respProps
  } = props;
  const { mode, setMode } = useColorScheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  React.useEffect(() => {
    if (defaultMode)
      setMode(defaultMode);
  }, [defaultMode]);
  const toggleMode = React.useCallback(() => {
    setMode(mode === "light" ? "dark" : "light");
  }, [mode]);
  const IconMode = mode === "dark" ? MoonIcon : SunIcon;
  if (!mounted) {
    return null;
  }
  return /* @__PURE__ */ jsx(Button, { variant: "ghost", ...respProps, onClick: toggleMode, startIcon: /* @__PURE__ */ jsx(IconMode, {}), size });
};
var ThemeSwitcher_default = ThemeSwitcher;
export {
  ThemeSwitcher_default as default
};
